// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__1ZoHm","price_sale":"styles_price_sale__dCKOz","price_real":"styles_price_real__3BWH4","sale":"styles_sale__2aIDz"};